
import { getAdminDataService } from '../services'

const getPaymentHistory = (from, size, filters) => {
    return new Promise(async (resolve, reject) => {
    await getAdminDataService.getPaymentHistory(from, size, filters)
        .then(response => resolve(response.data))
        .catch(err => err )
        // reject({ error: true }))
    })
}

export default getPaymentHistory;